"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIXER_TASK_FAILED = exports.DEBOUNCE_PROGRAM_UPDATES = void 0;
var MIXER_TASK_FAILED = exports.MIXER_TASK_FAILED = 'mixerTaskFailed';
var DEBOUNCE_PROGRAM_UPDATES = exports.DEBOUNCE_PROGRAM_UPDATES = 0; // value in milliseconds